/**
 * Module dependencies.
 */

import { AnimatedBackground } from './animated-background';
import { JSX } from 'react';
import { Language } from 'types/language';
import { StyledLink, StyledMenuItem } from './mobile-menu.style';
import { pageComponents } from 'constants/page-components';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  isOpen: boolean;
  languages: Language[];
  setIsOpen: (isOpen: boolean) => void;
};

/**
 * Export `MobileMenu` component.
 */

export function MobileMenu({ isOpen, setIsOpen }: Props): JSX.Element {
  const [translate] = useTranslation();

  return (
    <AnimatedBackground isOpen={isOpen} setIsOpen={setIsOpen}>
      {(options) => (
        <>
          {Object.keys(pageComponents).map((key) => (
            <StyledLink href={pageComponents[key]} key={key}>
              <StyledMenuItem onClick={options.closeMenu}>
                {translate(`links.${key}`)}
              </StyledMenuItem>
            </StyledLink>
          ))}
        </>
      )}
    </AnimatedBackground>
  );
}
